const { Fragment } = wp.element
const { BlockControls } = wp.blockEditor
const { Button } = wp.components
const { registerPlugin } = wp.plugins

const withInsertShortcodeButton = BlockEdit => {
  return props => {
    if (SUBlockEditorSettings.supportedBlocks.indexOf(props.name) === -1) {
      return <BlockEdit {...props} />
    }

    return (
      <Fragment>
        <BlockEdit {...props} />
        <BlockControls
          controls={[
            {
              icon: (
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10,3L3,3L3,21L10,21L10,17L7,17L7,7L10,7L10,3ZM14,3L21,3L21,21L14,21L14,17L17,17L17,7L14,7L14,3Z" />
                </svg>
              ),
              title: SUBlockEditorL10n.insertShortcode,
              onClick: () => {
                window.SUG.App.insert('block', { props: props })
              }
            }
          ]}
        />
      </Fragment>
    )
  }
}


const insertShortcodeHandler = () => {
  const { dispatch, select } = wp.data
  const { createBlock } = wp.blocks
  const blockEditor = select('core/block-editor')
  const selectedBlockId = blockEditor.getSelectedBlockClientId()
  const selectedBlock = selectedBlockId ? blockEditor.getBlock(selectedBlockId) : null

  if (selectedBlock) {
    const blockType = wp.blocks.getBlockType(selectedBlock.name)

    if (blockType && blockType.attributes && (blockType.attributes.content || selectedBlock.name === 'core/shortcode')) {
      window.SUG.App.insert('block', { props: {
        name: selectedBlock.name,
        attributes: selectedBlock.attributes,
        setAttributes: (newAttrs) => {
          dispatch('core/block-editor').updateBlockAttributes(selectedBlock.clientId, newAttrs)
        }
      }})
      return
    }
  }

  const shortcodeBlock = createBlock('core/shortcode', { text: '' })
  const insertionIndex = blockEditor.getBlockInsertionPoint()
  dispatch('core/block-editor').insertBlock(shortcodeBlock, insertionIndex.index, insertionIndex.rootClientId)
  dispatch('core/block-editor').selectBlock(shortcodeBlock.clientId)

  setTimeout(() => {
    window.SUG.App.insert('block', { props: {
      name: 'core/shortcode',
      attributes: { text: '' },
      setAttributes: (newAttrs) => {
        dispatch('core/block-editor').updateBlockAttributes(shortcodeBlock.clientId, newAttrs)
      }
    }})
  }, 100)
}

const HeaderToolbarButton = () => {
  return (
    <Button
      icon={
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M10,3L3,3L3,21L10,21L10,17L7,17L7,7L10,7L10,3ZM14,3L21,3L21,21L14,21L14,17L17,17L17,7L14,7L14,3Z" />
        </svg>
      }
      label={SUBlockEditorL10n.insertShortcode}
      onClick={insertShortcodeHandler}
      className="su-insert-shortcode-button"
    />
  )
}

const ShortcodeUltimateToolbar = () => {
  return (
    <wp.editPost.PluginMoreMenuItem
      icon={
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M10,3L3,3L3,21L10,21L10,17L7,17L7,7L10,7L10,3ZM14,3L21,3L21,21L14,21L14,17L17,17L17,7L14,7L14,3Z" />
        </svg>
      }
      onClick={insertShortcodeHandler}
    >
      {SUBlockEditorL10n.insertShortcode}
    </wp.editPost.PluginMoreMenuItem>
  )
}

registerPlugin('shortcodes-ultimate-toolbar', {
  render: ShortcodeUltimateToolbar
})

if (SUBlockEditorSettings.showToolbarButton === 'on') {
  wp.domReady(() => {
    const toolbarSelector = '.edit-post-header-toolbar, .editor-header__toolbar'

    const addButtonToToolbar = () => {
      const toolbar = document.querySelector(toolbarSelector)

      if (toolbar && !document.querySelector('.su-insert-shortcode-button')) {
        const buttonContainer = document.createElement('div')
        buttonContainer.style.display = 'inline-flex'
        buttonContainer.style.alignItems = 'center'
        buttonContainer.style.marginLeft = '8px'

        toolbar.appendChild(buttonContainer)

        wp.element.render(
          wp.element.createElement(HeaderToolbarButton),
          buttonContainer
        )
      }
    }

    addButtonToToolbar()

    const observer = new MutationObserver(() => {
      addButtonToToolbar()
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
  })
}

if (SUBlockEditorSettings.showBlockControlsButton === 'on') {
  wp.hooks.addFilter(
    'editor.BlockEdit',
    'shortcodes-ultimate/with-insert-shortcode-button',
    withInsertShortcodeButton
  )
}
